import { makeStyles } from "tss-react/mui";

const styles = makeStyles()((theme: any) => ({
  helperBotList: {
    display: "flex",
    flexDirection: "column",
    gap: 32,

    [theme.breakpoints.down("xl")]: {
      padding: "0 32px",
    },
  },

  helperBotDescription: {
    display: "-webkit-box",
    WebkitLineClamp: 3,
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxHeight: "63px", // Approximately 2 lines of text with 14px font size
    lineHeight: "21px",
  },

  helperBotListItem: {
    display: "flex",
    gap: 32,
    backgroundColor: "rgb(36, 36, 36)",
    borderRadius: 16,
    boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
    alignItems: "center",
    border: "1px solid black",

    [theme.breakpoints.down("xl")]: {
      gap: 24,
    },

    [theme.breakpoints.down("lg")]: {
      gap: 16,
    },

    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
    },
  },

  helperBotListItemImage: {
    width: 280,
    height: 200,
    borderTopLeftRadius: 16,
    borderBottomLeftRadius: 16,
    objectFit: "cover",

    maskImage: "linear-gradient(to right, black 60%, transparent 100%)",
    WebkitMaskImage: "linear-gradient(to right, black 60%, transparent 100%)",

    [theme.breakpoints.down("sm")]: {
      width: "100%",
      objectPosition: "center",
      maskImage: "linear-gradient(to bottom, black 60%, transparent 100%)",
      WebkitMaskImage:
        "linear-gradient(to bottom, black 60%, transparent 100%)",
    },
  },
  helperBotListItemContent: {
    display: "flex",
    gap: 64,
    padding: "24px 32px",
    height: 150,
    justifyContent: "space-between",

    [theme.breakpoints.down("xl")]: {
      padding: "16px 24px",
      gap: 24,
    },

    [theme.breakpoints.down("lg")]: {
      padding: "16px 16px",
      gap: 16,
    },

    [theme.breakpoints.down("sm")]: {
      height: "initial",
      flexDirection: "column",
    },
  },
  helperBotListItemDetail: {
    display: "flex",
    flexDirection: "column",
    gap: 18,
  },

  helperBotListItemTitle: {
    display: "flex",
    alignItems: "center",
    gap: 8,

    "& img": {
      width: 32,
      height: 32,
    },

    [theme.breakpoints.down("sm")]: {
      justifyContent: "center",
    },
  },

  helperBotListItemTitleText: {
    color: "white",
    fontSize: 20,
    fontFamily: "Philosopher",
    fontWeight: 900,
  },

  helperBotListItemStatus: {
    color: "#32CD32", // Deluxe green color
    fontSize: 16,
    fontFamily: "Philosopher",
    fontWeight: 900,
  },

  helperBotListItemAction: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "center",
    width: "150px",

    [theme.breakpoints.down("sm")]: {
      width: "initial",
      flexDirection: "row",
    },
  },

  helperBotListItemWithdrawButton: {
    background: "linear-gradient(135deg, rgb(239, 142, 129), rgb(168, 61, 65))",
    borderRadius: 12,
    color: "white",
    fontSize: 16,
    fontFamily: "Philosopher",
    fontWeight: 900,
    padding: "8px 8px",
    textTransform: "none",
    maxWidth: 140,
    width: "100%",
    lineHeight: "20px",

    "&:disabled": {
      filter: "grayscale(100%)",
    },
  },

  helperBotListItemHireButton: {
    background: "linear-gradient(135deg, rgb(91, 176, 134), rgb(78, 166, 112))",
    borderRadius: 12,
    color: "white",
    fontSize: 16,
    fontFamily: "Philosopher",
    fontWeight: 900,
    padding: "8px 8px",
    textTransform: "none",
    maxWidth: 140,
    width: "100%",
    lineHeight: "20px",
  },

  helperBotListItemCreditInfos: {
    display: "flex",
    flexDirection: "column",
    gap: 4,
    marginBottom: 4,

    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },

  helperBotListItemCredit: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 12,
    position: "relative",

    [theme.breakpoints.down("sm")]: {
      gap: 4,
    },
  },

  helperBotListItemCreditCount: {
    color: "white",
    fontSize: 20,
    fontFamily: "Philosopher",
    fontWeight: 900,
    padding: "8px 16px",
    textTransform: "none",
    border: "1px solid black",
    backgroundColor: "rgb(22, 22, 22)",
    borderRadius: "16px",
    minWidth: 80,
    textAlign: "center",
  },

  helperBotListItemCashAmount: {
    color: "white",
    fontSize: 16,
    fontFamily: "Philosopher",
    fontWeight: 900,
    padding: "4px 8px",
    textTransform: "none",
    border: "1px solid black",
    backgroundColor: "rgb(22, 22, 22)",
    borderRadius: "16px",
    minWidth: 80,
    textAlign: "center",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: 4,

    "& img": {
      width: 20,
      height: 20,
    },
  },

  helperBotCashRequiredLabel: {
    color: "grey",
    fontSize: 11,
    fontFamily: "Philosopher",
    fontWeight: 900,
    whiteSpace: "nowrap",
    textTransform: "none",
    position: "absolute",
    right: "calc(100% + 8px)",
    top: "50%",
    transform: "translateY(-50%)",

    [theme.breakpoints.down("sm")]: {
      position: "unset",
      right: "initial",
      color: "white",
      fontSize: 12,
      top: "initial",
      transform: "initial",
    },
  },

  helperBotListItemCreditLabel: {
    color: "white",
    fontSize: 14,
    fontFamily: "Philosopher",
    fontWeight: 900,
    whiteSpace: "nowrap",
    textTransform: "none",
  },

  helperBotListItemInfo: {
    display: "flex",
    gap: 16,

    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      alignItems: "center",
      gap: 0,
    },
  },

  helperBotListItemRank: {
    display: "flex",
    gap: 16,

    [theme.breakpoints.down("lg")]: {
      gap: 8,
    },
  },

  helperBotListItemTime: {
    display: "flex",
    gap: 16,

    [theme.breakpoints.down("lg")]: {
      gap: 8,
    },
  },

  helperBotActionButtonList: {
    gap: 8,
    width: "100%",
    display: "flex",
    flexDirection: "column",

    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
    },
  },
}));

export default styles;
